import {
  SlDetails,
  details_styles_default
} from "./chunk.7Y7N6HGI.js";
import {
  focusVisibleSelector
} from "./chunk.ZLFKGBZ6.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  $,
  r,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/details/details.ts
import { t } from "i18next";

// src/components/details/details.style.ts
var details_style_default = r` ${details_styles_default} ${component_mobile_styles_default} .details__header { padding: 0; } .details { background-color: var(--sl-color-neutral-0); } button { all: unset; padding: var(--sl-spacing-medium) 0 var(--sl-spacing-medium) var(--sl-spacing-medium); } :not(.details--has-actions) button { padding-right: var(--sl-spacing-medium); } .details--has-actions button.details__summary-icon { padding: 0; } button${focusVisibleSelector} { box-shadow: var(--sl-focus-ring); outline: none; } .details__summary--inner { width: 100%; } .details--open .details__header { background-color: var(--sl-color-primary-100); } .details.details--open .details__header { border-bottom-left-radius: 0; border-bottom-right-radius: 0; } :host(.accordion-details) .details { border-radius: 0; border-bottom-width: 0; } :host(.accordion-details--first-child) .details { border-top-left-radius: var(--sl-border-radius-large); border-top-right-radius: var(--sl-border-radius-large); } :host(.accordion-details--last-child) .details { border-bottom-left-radius: var(--sl-border-radius-large); border-bottom-right-radius: var(--sl-border-radius-large); border-bottom-width: 1px; } :host(.accordion-details--striped-even) .details__header { background-color: var(--sl-color-neutral-0); } :host(.accordion-details--striped-even) .details.details--open .details__header { border-bottom: solid 1px var(--sl-color-gray-300); } :host(.accordion-details--striped-odd) .details__header { background-color: var(--sl-color-gray-100); } .details__summary--suffix { padding: var(--sl-spacing-medium) var(--sl-spacing-medium) var(--sl-spacing-medium) 0; display: flex; align-items: center; } `;

// src/components/details/details.ts
var FadvDetails = class extends SlDetails {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "[default]", "summary", "actions", "summary-icon");
  }
  renderHeaderButton() {
    const hasActionsSlot = this.hasSlot.test("actions");
    const actionsSlotTemplate = $`<div class="details__summary--suffix"><slot name="actions"></slot>${this.renderSummaryIcon()}</div>`;
    return $`<button part="summary" class="details__summary" aria-expanded=${this.open ? "true" : "false"} aria-controls="content" aria-disabled=${this.disabled ? "true" : "false"} tabindex=${this.disabled ? "-1" : "0"} @click=${this.handleSummaryClick} @keydown=${this.handleSummaryKeyDown} ><div class="details__summary--inner"><slot name="summary">${this.summary}</slot></div>${!hasActionsSlot ? this.renderSummaryIcon() : w}</button>${hasActionsSlot ? actionsSlotTemplate : w} `;
  }
  renderSummaryIcon() {
    const label = this.open ? t("components:details.collapsePanel") : t("components:details.expandPanel");
    const summaryIconSlot = $`<slot name="summary-icon"><fadv-icon name="${this.summaryIconName || "chevron-right"}" library="${this.summaryIconLibrary || "system"}"></fadv-icon></slot>`;
    if (this.hasSlot.test("actions")) {
      return $`<button part="summary-icon" class="details__summary-icon" aria-expanded=${this.open ? "true" : "false"} aria-controls="content" aria-label=${label} aria-disabled=${this.disabled ? "true" : "false"} tabindex=${this.disabled ? "-1" : "0"} @click=${this.handleSummaryClick} @keydown=${this.handleSummaryKeyDown} >${summaryIconSlot}</button>`;
    }
    return $`<span part="summary-icon" class="details__summary-icon">${summaryIconSlot}</span>`;
  }
  render() {
    return $`<section part="base" class=${o({
      details: true,
      "details--open": this.open,
      "details--disabled": this.disabled,
      "details--has-actions": this.hasSlot.test("actions")
    })} ><header part="header" id="header" class="details__header">${this.renderHeaderButton()}</header><div class="details__body"><div part="content" id="content" class="details__content" role="region" aria-labelledby="header"><slot></slot></div></div></section>`;
  }
};
FadvDetails.styles = details_style_default;
__decorateClass([
  e({ attribute: "summary-icon-library" })
], FadvDetails.prototype, "summaryIconLibrary", 2);
__decorateClass([
  e({ attribute: "summary-icon-name" })
], FadvDetails.prototype, "summaryIconName", 2);
FadvDetails = __decorateClass([
  n("fadv-details")
], FadvDetails);

export {
  FadvDetails
};
